export class LoanApplicationTransition {
    toStage: LoanApplicationPipelineStage;
    entityId: string;
    createdAt: string;
    updatedAt: string;
    fromStage: string;
    id: string;


    constructor(toStage: LoanApplicationPipelineStage, entityId?: string, createdAt?: string, updatedAt?: string, fromStage?: string, id?: string) {
        this.toStage = toStage;
        this.entityId = entityId;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.fromStage = fromStage;
        this.id = id;
    }
}

export enum LoanApplicationPipelineStage {
    Verification = 'VERIFICATION',
    PreCreditAssessment = 'PRE_CREDIT_ASSESSMENT',
    DetailedCreditAssessment = 'DETAILED_CREDIT_ASSESSMENT',
    Sanction = 'SANCTION',
    Rejection = 'REJECTION'
}
